<template>
  <div class="animated fadeIn" style="height:100%; width:auto;">
    <b-card>
      <div slot="header">
        History Payment & Settlement
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="close()">
            <i class="fa fa-close"></i> {{$t('close')}}
          </button>
        </div>
      </div>

      <b-row>
        <b-col lg="10">
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>No. Agreement</label>
                </b-input-group-prepend>
                <b-form-input
                  readonly
                  v-model="model.no_agreement"
                  @keyup.13.native="lkuPinjamanShow=true"
                  :state="!$v.model.pinjamankey.$error"
                ></b-form-input>
                <b-input-group-append>
                  <b-btn text="Button" @click="lkuPinjamanShow=true">
                    <i class="fa fa-search"></i>
                  </b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>No. Kontrak</label>
                </b-input-group-prepend>
                <b-form-input
                  readonly
                  v-model="model.nokontrak"
                ></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Tenor</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.tenor" readonly class="text-right"></b-form-input>
                 <b-input-group-prepend><span class="input-group-text">Bulan</span></b-input-group-prepend>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Go Live - Maturity Date</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.startdate_frmt" readonly></b-form-input>
                <b-input-group-prepend><span class="input-group-text">-</span></b-input-group-prepend>
                    <b-form-input v-model="model.duedate_frmt" readonly></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Debitur Name</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.debitur_name" readonly></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Debitur No (CIF)</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.CustCode" readonly></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Penggunaan</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.penggunaan" disabled></b-form-input>
              </b-input-group>
              
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Virtual Account No	</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.vanumber" readonly></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
           <b-row>
            <b-col offset="6" lg="6">
              <div class="text-right">
                <button class="btn btn-success mr-1" @click="getHistoryPay()">
                  <i class="fa fa-refresh"></i> {{$t('refresh')}}
                </button>
              </div>
            </b-col>
          </b-row>
        </b-col>
        
        <!-- <b-col lg="4">
          <b-col lg="10">
            <b-input-group>
              <b-input-group-prepend v-if="model.modelkredit=='PAB'">
                <label>Tenor</label>
              </b-input-group-prepend>
              <b-input-group-prepend v-else>
                <label>Plafond Pinjaman</label>
              </b-input-group-prepend>
              <my-number
                v-if="model.modelkredit=='PAB'"
                class="form-control text-right"
                v-model="model.principal"
                :precision="2"
                disabled
              ></my-number>
              <my-number
                v-else
                class="form-control text-right"
                v-model="model.principal"
                :precision="2"
                disabled
              ></my-number>
              <b-input-group-prepend>
                <span class="input-group-text" style="width:70px;">{{model.matauang}}</span>
              </b-input-group-prepend>
            </b-input-group>
            <b-input-group>
              <b-input-group-prepend>
                <label>Jangka Waktu</label>
              </b-input-group-prepend>
              <my-number class="form-control text-right" v-model="model.tenor" disabled></my-number>
              <b-input-group-prepend>
                <span class="input-group-text" style="width:70px;">bulan</span>
              </b-input-group-prepend>
            </b-input-group>
            <b-input-group>
              <b-input-group-prepend>
                <label>Bunga per tahun</label>
              </b-input-group-prepend>
              <my-number
                class="form-control text-right"
                v-model="model.interest"
                :precision="2"
                disabled
              ></my-number>
              <b-input-group-prepend>
                <span class="input-group-text" style="width:70px;">%</span>
              </b-input-group-prepend>
            </b-input-group>
            <b-input-group v-if="model.modelkredit=='PAB'">
              <b-input-group-prepend>
                <label>Angsuran per bulan</label>
              </b-input-group-prepend>
              <my-number
                class="form-control text-right"
                v-model="model.installment_amount"
                :precision="2"
                disabled
              ></my-number>
              <b-input-group-prepend>
                <span class="input-group-text" style="width:70px;">{{model.matauang}}</span>
              </b-input-group-prepend>
            </b-input-group>
            <b-input-group v-else>
              <b-input-group-prepend>
                <label>Bunga Over Draft</label>
              </b-input-group-prepend>
              <my-number
                class="form-control text-right"
                v-model="model.interestod"
                :precision="2"
                disabled
              ></my-number>
              <b-input-group-prepend>
                <span class="input-group-text" style="width:70px;">%</span>
              </b-input-group-prepend>
            </b-input-group>
          </b-col>
        </b-col> -->
      </b-row>
      <hr />
      <b-card border-variant="info" header="History" align="center" no-body>
        <template v-slot:header v-if="(filterShow=='Hide')">
          <b-row>
            <b-col lg="3">
              <b-input-group size="sm" class="mt-1">
                <b-input-group-prepend>
                  <span class="pt-1 mr-1">FILTER</span>
                </b-input-group-prepend>
                <b-form-input
                  v-model="filter"
                  type="search"
                  id="filterInput"
                  placeholder="Type to Search"
                ></b-form-input>
                <b-input-group-append>
                  <b-button :disabled="!filter" @click="clearFilter">Clear</b-button>
                </b-input-group-append>
              </b-input-group>
              <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch>
                <b>{{ filterShow }}</b> Filter
              </b-form-checkbox>
            </b-col>
            <b-col lg="9">
              <b-form-group
                label="FILTER ON :"
                label-cols-sm="1"
                description="Leave all unchecked to filter on all data"
                class="mb-0"
              >
                <b-form-checkbox-group v-model="filterOn" class="mt-1">
                  <b-form-checkbox
                    v-for="(item,index) in tblFields.filter(dt => dt.filterable==true) "
                    :key="index"
                    :value="item.key"
                  >{{item.label}}</b-form-checkbox>
                </b-form-checkbox-group>
              </b-form-group>
            </b-col>
          </b-row>
        </template>
        <b-table
          class="mb-0"
          ref="table"
          outlined
          responsive
          striped
          hover
          small
          style="font-size:smaller;"
          :items="tblData.items"
          :fields="tblFields"
          :current-page="tblData.page"
          :per-page="tblData.limit"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc"
          :key="tblData.limit"
          show-empty
          sticky-header 
          :filter="filter"
          :filterIncludedFields="filterOn"
          @filtered="onFiltered"
        >
          <template v-slot:cell(tglpaym)="data">{{ data.item.tglpaym | moment("DD-MM-YYYY") }}</template>
          <template v-slot:cell(post_date)="data">{{ data.item.post_date | moment("DD-MM-YYYY") }}</template>
          <template v-slot:cell(totalbyr)="data">
            {{data.item.totalbyr|numFormat('0,0.00')}}
          </template>
          <template v-slot:cell(custinfo)="data">{{ data.item.CustName }} | {{ data.item.custcode }}</template>
          <template v-slot:cell(disc_amt)="data">{{data.item.disc_amt|numFormat('0,0.00')}}</template>
          <template v-slot:cell(settl_amt)="data">{{data.item.settl_amt|numFormat('0,0.00')}}</template>
          <template v-slot:cell(totalbank)="data">{{data.item.totalbank|numFormat('0,0.00')}}</template>
          <template v-slot:cell(pbb_amt)="data">{{data.item.pbb_amt|numFormat('0,0.00')}}</template>
          
          <template v-slot:empty="scope">
            <h6 class="text-center">{{ scope.emptyText }}</h6>
          </template>
          <template v-slot:emptyfiltered="scope">
            <h6>{{ scope.emptyFilteredText }}</h6>
          </template>
        </b-table>
        <b-row class="mt-2">
          <b-col lg="4" align="left">
            <div class="ml-2">
              Showing {{(tblData.page - 1) * tblData.limit + 1}}
              to
              <span
                v-if="((tblData.page * tblData.limit)>tblData.total)"
              >{{tblData.total}}</span>
              <span v-else>{{tblData.page * tblData.limit}}</span>
              of {{tblData.total}} entries.
            </div>
          </b-col>
          <b-col cols="4">
            <b-row class="justify-content-center">
              <b-col cols="12">
                <div style="display: flex;margin:0;padding:0;">
                  <div style="margin:0;padding:5px;width:500px; text-align:center;">
                    <span class="mr-1">limit per page :</span>
                    <select v-model="tblData.limit" style="width:60px;">
                      <option>10</option>
                      <option>15</option>
                      <option>20</option>
                      <option>25</option>
                      <option>30</option>
                      <option>40</option>
                      <option>50</option>
                      <option>60</option>
                      <option>70</option>
                      <option>80</option>
                      <option>90</option>
                    </select>
                  </div>
                </div>
              </b-col>
              <b-col cols="12">
                <div style="display: flex;margin:0;padding:0;">
                  <div style="margin:0;padding:5px;width:500px; text-align:center;">
                    <b-form-checkbox
                      v-model="filterShow"
                      value="Hide"
                      unchecked-value="Show"
                      switch
                    >
                      <b>{{ filterShow }}</b> Filter
                    </b-form-checkbox>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-col>
          <b-col lg="4">
            <b-pagination
              class="ml-1"
              align="right"
              :total-rows="tblData.total"
              :per-page="tblData.limit"
              v-model="tblData.page"
            ></b-pagination>
          </b-col>
        </b-row>
      </b-card>
    </b-card>
    <b-modal
      v-model="lkuPinjamanShow"
      size="lg"
      :hide-footer="true"
      title="Daftar Pinjaman"
      :centered="true"
    >
      <lku-pinjaman @click="onSelectLkuPinjaman"></lku-pinjaman>
    </b-modal>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
  </div>
</template>

<script>
import toastr from "mini-toastr";
import moment from "moment";
import myNumber from "../../components/my-number";
import lkuPinjaman from "./lkuPinjaman";
import pinjaman from "../../apis/pinjamankredit";
import pinjamanpayment from "../../apis/pinjamanpayment";
// import crud from "../../apis/crud";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
toastr.init();

export default {
  components: { myNumber, lkuPinjaman,Loading },
  mixins: [validationMixin],
  validations: {
    model: {
      pinjamankey: { required },
    },
  },
  data() {
    return {
      isLoading:false,
      model: { pinjamankey: "" },
      lkuPinjamanShow: false,
      tblData: {
        items: [],
        page: 1,
        limit: 15,
        total: 0,
        sortBy: "tglpaym",
        sortDesc: true,
      },
      filterShow: "Show",
      filter: null,
      filterOn: [],
    };
  },
  computed: {
    tblFields() {
      const fields = [
        {
          key: "paymno",
          thStyle: "width:100px",
          label: "Trx. Number",
          sortable: true,
          filterable: true,
        },
        {
          key: "tglpaym",
          thStyle: "width:100px",
          label: "Trx. Date",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "post_date",
          thStyle: "width:100px",
          label: "Post Date",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "createby",
          thStyle: "width:100px",
          label: "Issued By",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "custinfo",
          label: "Debitur | CIF",
          thStyle: "width:180px",
          sortable: true,
          filterable: true,
        },
        // {
        //   key: "uraian",
        //   label: "Description",
        //   filterable: true,
        // },
        // {
        //   key: "paymethod",
        //   label: "Payment Method",
        //   sortable: true,
        //   filterable: true,
        // },
        // {
        //   key: "tgl_terima",
        //   label: "Due/Efective Date",
        //   thStyle: "width:80px",
        //   thClass: "text-center",
        //   tdClass: "text-right",
        //   sortable: true,
        //   filterable: true,
        // },
        // {
        //   key: "namabank",
        //   label: "Destination Bank/Acc.",
        //   thStyle: "width:150px",
        //   sortable: true,
        //   filterable: true,
        // },
        {
          key: "totalbank",
          label: "Payment Receive",
          thStyle: "width:120px",
          thClass: "text-right",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "settl_amt",
          label: "Total Settlement",
          thStyle: "width:120px",
          thClass: "text-right",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "disc_amt",
          label: "Payment Discount",
          thStyle: "width:120px",
          thClass: "text-right",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "pbb_amt",
          label: "Prepaid",
          thStyle: "width:120px",
          thClass: "text-right",
          tdClass: "text-right",
          sortable: true,
        },
        // {
        //   key: "totalbyr",
        //   label: "Payment Nett Amount",
        //   thStyle: "width:120px",
        //   thClass: "text-right",
        //   tdClass: "text-right",
        //   sortable: true,
        // },
      ];
      //   const dims = this.$store.state.dimension;
      //   for (let i = 0; i < dims.length; i += 1) {
      //     fields.push({
      //       key: `${dims[i].value}Txt`,
      //       thStyle: "width:100px",
      //       label: dims[i].text,
      //       sortable: true,
      //     });
      //   }
      return fields;
    },
  },
  created: async function () {
    if (this.$route.params.pinjamankey) {
      toastr.info("Loading Payment Detail, please wait");
      try {
        const [data] = await pinjaman.detail(this.$route.params.pinjamankey);
        const dataDetail = data[0][0];
        this.filterShow = "Show";
        this.model.pinjamankey = dataDetail.pinjamankey;
        this.model.nokontrak = dataDetail.no_kontrak;
        this.model.tglkontrak = dataDetail.tgl_kontrak
          ? moment(dataDetail.tgl_kontrak).format("YYYY-MM-DD")
          : "";
        this.model.debitur_name = dataDetail.CustName;
        this.model.penggunaan = dataDetail.uraian;
        this.model.modelkredit = dataDetail.model_pinjaman;
        this.model.matauang = dataDetail.matauang;
        this.model.principal = dataDetail.principal;
        this.model.tenor = dataDetail.tenor;
        this.model.interest = dataDetail.interest;
        this.model.installment_amount = dataDetail.installment_amount;
        this.model.interstod = dataDetail.interstod;
        this.model.nasabahkey = dataDetail.nasabahkey;
        this.getHistoryPay();
        this.lkuPinjamanShow = false;
        toastr.clear;
      } catch (error) {
        console.log("error : ", error);
        toastr.error(JSON.stringify(error), "ERROR MESSAGE");
      }
    } else {
      // const [a,c,d,e] = await Promise.all([arpayment.currency(),await arpayment.argroup(),await arpayment.potongan(),
      //                 crud.list({tablename: "vwcollector",page: 1,limit: 1000,sortBy: "collector_name",sortDesc: false})]) ;
      // this.currency = a;
      // this.arGroups = c;
      // this.potongans = d;
      //     this.collectors = e.reduce((newArr,item) =>{
      //         newArr.push({ value: item.collector_id, text: item.collector_name});
      //         return newArr;
      //     },[]);
    }
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.tblData.total = filteredItems.length;
      this.tblData.page = 1;
    },
    clearFilter() {
      this.filterOn = [];
      this.filter = "";
    },
    onSelectLkuPinjaman(_selected) {
      this.filterShow = "Show";
      this.model.pinjamankey = _selected.pinjamankey;
      this.model.nokontrak = _selected.no_kontrak;
      this.model.tglkontrak = _selected.tgl_kontrak
        ? moment(_selected.tgl_kontrak).format("YYYY-MM-DD")
        : "";
      this.model.debitur_name = _selected.CustName;
      this.model.penggunaan = _selected.uraian;
      this.model.modelkredit = _selected.model_pinjaman;
      this.model.matauang = _selected.matauang;
      this.model.principal = _selected.principal;
      this.model.tenor = _selected.tenor;
      this.model.interest = _selected.interest;
      this.model.installment_amount = _selected.installment_amount;
      this.model.interstod = _selected.interstod;
      this.model.nasabahkey = _selected.nasabahkey;
      this.model.no_agreement = _selected.no_agreement;
      this.model.tenor = _selected.tenor;
      this.model.startdate_frmt = moment(_selected.startdate).format('DD-MM-YYYY');
      this.model.duedate_frmt = moment(_selected.duedate).format('DD-MM-YYYY');
      this.model.CustCode = _selected.CustCode;
      this.model.vanumber = _selected.vanumber;
      this.getHistoryPay();
      this.lkuPinjamanShow = false;
    },
    async getHistoryPay() {
      this.isLoading=true;
      const { nasabahkey } = this.model;
      const getDt = await pinjamanpayment.paymenthistory(nasabahkey);
      this.tblData.items = getDt;
      this.tblData.total =getDt.length || 0;
      this.isLoading=false;
    },
    close() {
      router.push("home");
    },
  },
};
</script>
